<section>
  <app-head-generative-ai selectedNavItem="overview"></app-head-generative-ai>

  <div class="container-full bg-media py-6">
    <div class="container my-4" *ngIf="page && !loading">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h2 class="title is-2 mb-5 has-text-white">Overview</h2>
          <div class="has-text-white" [innerHTML]="page.content"></div>
        </div>
        <div class="column is-offset-1 is-5" *ngIf="page?.link1">
          <a
            (click)="isOpen = true"
            (keydown)="isOpen = true"
            tabindex="0"
            class="ghost flex align-center justify-start"
          >
            <figure class="position: relative">
              <img
                class="is-block"
                [src]="page.image1.sizes.videoCard"
                [alt]="'photo of ' + page.title"
              />
              <div class="video-layer">
                <i class="far fa-play-circle has-text-white is-size-1"></i>
              </div>
            </figure>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Loader Page -->
  <div *ngIf="!page || loading">
    <div class="container">
      <div class="columns">
        <div class="column is-8">
          <div
            class="mt-6 temporary-item temporary-item--dark temporary-desc"
          ></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
        </div>
        <div class="column is-3 is-offset-1">
          <div class="lc lc--regular">
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Related posts -->
  <div
    class="container-full bg-white-bis mb-4"
    *ngIf="relatedPosts?.length && tag"
  >
    <div class="container">
      <div class="columns p-t-md">
        <div class="column is-12">
          <div class="flex flex-wrap align-center space-between">
            <h2 class="m-b-0">From the AI Wonk</h2>
            <a
              routerLink="/wonk/tags/{{ tag.id }}-{{ tag.slug }}"
              class="button is-link"
              *ngIf="relatedPosts.length > 3"
              >More related posts</a
            >
          </div>
        </div>
      </div>
      <div class="columns flex flex-wrap p-b-md">
        <div
          class="column is-12-mobile is-6-tablet is-4-desktop"
          *ngIf="!loadingPosts && !relatedPosts.length"
        >
          <p>No post found.</p>
        </div>
        <!-- Blog post loop  -->
        <ng-container *ngIf="!loadingPosts">
          <ng-container *ngFor="let post of relatedPosts; let i = index">
            <div
              class="column is-12-mobile is-6-tablet is-4-desktop"
              *ngIf="i < 3"
            >
              <app-post-card [post]="post"></app-post-card>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Loader Related Posts -->
  <div class="container-full bg-white-bis mb-xl py-6" *ngIf="loadingPosts">
    <div class="container">
      <div class="columns">
        <div class="column is-4">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-4">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-4">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Featured cards -->
  <div class="container mt-5">
    <div class="columns">
      <div class="column is-12">
        <h2 class="m-b-0">Featured</h2>
      </div>
    </div>
    <app-featured-card-list
      [loading]="loadingFeaturedCards"
      [featuredCards]="featuredCards"
    ></app-featured-card-list>
  </div>
  <!-- Policies and Initiatives -->
  <div
    class="container-full has-background-white-ter py-6 mt-4"
    *ngIf="policies?.length"
  >
    <div class="container">
      <div class="columns">
        <div class="column is-12">
          <div class="flex flex-wrap align-center space-between">
            <h2 class="m-b-0">Policies & initiatives</h2>
            <a
              routerLink="/genai/policies-and-initiatives"
              class="button is-link"
              >View all policies & initiatives
            </a>
          </div>
        </div>
      </div>

      <div class="columns is-multiline" *ngIf="!loadingPolicies">
        <div
          class="column"
          *ngFor="let featuredCard of policies"
          [ngClass]="{
            'is-4': policies?.length <= 3,
            'is-4-tablet is-3-desktop': policies?.length === 4,
            'is-3': policies?.length > 4
          }"
        >
          <app-featured-card
            [featuredCard]="featuredCard"
            [layout]="FeaturedCardLayout.Vertical"
          ></app-featured-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Loader Policies -->
  <div class="container-full bg-white-bis py-6 mt-5" *ngIf="loadingPolicies">
    <div class="container mt-6">
      <div class="columns">
        <div class="column is-3">
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
        </div>
        <div class="column is-3 is-offset-6">
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-12-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Video modal -->
<div class="modal modal-large is-active" *ngIf="isOpen">
  <div class="modal-background"></div>
  <div class="modal-content">
    <iframe
      id="youtube-player"
      width="100%"
      height="500"
      style="height: 500px"
      [src]="videoUrl"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</div>
